import gtm from "google-tag-manager/gtm.service";

export const UI_STATE = "emun.ui.state";
export const UI_ROUTER = "emun.ui.router";
export default function initializeGTM($rootScope, $location) {
  [
    "$stateChangeError",
    "$stateChangeStart",
    "$stateChangeSuccess",
    "$stateChangeCancel",
  ].forEach((eventName) =>
    $rootScope.$on(
      eventName,
      (event, toState, toParams, fromState, fromParams, error) =>
        gtm(
          { event: `CLEAR!${UI_STATE}`, [UI_STATE]: null, [eventName]: null },
          {
            event: UI_STATE,
            [eventName]: {
              ...toState,
              params: toParams,
            },
            [UI_STATE]: {
              url: $location.url(),
              event,
              from: {
                name: fromState.name,
                url: fromState.url,
                params: fromParams,
              },
              to: {
                name: toState.name,
                url: toState.url,
                params: toParams,
              },
              error,
            },
          }
          // {
          //   event: $location.url(),
          //   kind: eventName,
          //   from: {
          //     name: fromState.name,
          //     url: fromState.url,
          //     params: fromParams,
          //   },
          //   to: {
          //     name: toState.name,
          //     url: toState.url,
          //     params: toParams,
          //   },
          // },
          // {
          //   event: toState.name,
          //   kind: eventName,
          //   from: {
          //     name: fromState.name,
          //     url: fromState.url,
          //     params: fromParams,
          //   },
          //   to: {
          //     name: toState.name,
          //     url: toState.url,
          //     params: toParams,
          //   },
          // }
        )
    )
  );
  ["$locationChangeStart", "$locationChangeSuccess"].forEach((eventName) =>
    $rootScope.$on(eventName, (event, toUrl, fromUrl) =>
      gtm(
        { event: `CLEAR!${UI_ROUTER}`, [UI_ROUTER]: null },
        {
          event: UI_ROUTER,
          [UI_ROUTER]: {
            url: $location.url(),
            toUrl,
            fromUrl,
          },
        }
      )
    )
  );
}
